var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "mds-section",
    {
      staticClass: "scheduler-modal-section",
      class: { "scheduler-modal-section--edited": _vm.editedFeed },
      attrs: {
        bold: "",
        border: "none",
        size: 4,
        title: _vm.translate(_vm.title),
      },
      scopedSlots: _vm._u([
        {
          key: "mds-section-title-description",
          fn: function () {
            return [
              _c("mds-button", {
                attrs: {
                  variation: "icon-only",
                  icon: "question-circle",
                  type: "button",
                  target: "_blank",
                  href: _vm.supportUrl,
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("p", { staticClass: "scheduler-modal-description" }, [
        _vm._v("\n    " + _vm._s(_vm.translate(_vm.modalDescription)) + "\n  "),
      ]),
      _vm._v(" "),
      _c(
        "mds-stepper",
        _vm._g({ attrs: { size: "small" } }, _vm.$listeners),
        _vm._l(_vm.stepper, function (step) {
          return _c("mds-stepper-step", {
            key: step.id,
            attrs: { title: step.title, status: step.status },
            nativeOn: {
              click: function ($event) {
                return _vm.onClick(step.id)
              },
            },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }